import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

class Refund extends React.Component {
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Refund Policy | LA Language Academy Australia</title>
          <meta name="description" content="Understand LA Language Academy's refund policies for all courses and services. Learn about our transparent and hassle-free refund process." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/refund-policies`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="Refund Policy | LA Language Academy Australia" />
          <meta name="twitter:description" content="Understand LA Language Academy's refund policies for all courses and services. Learn about our transparent and hassle-free refund process." />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/refund-policies`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Refund Policy | LA Language Academy Australia" />
          <meta property="og:description" content="Understand LA Language Academy's refund policies for all courses and services. Learn about our transparent and hassle-free refund process." />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <div className="innerPage">
          <Header />
          <div className="hero-section-gray mt-80">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h1 className="primary-heading mb-0 text-uppercase mfw-600">
                    Refund Policies
                  </h1>
                  <span className="effective-date">
                    Effective Date: 00-00-0000
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="term-content">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <ul className="m-0 term-content-list">
                    <li>
                      We don't offer any refund in any given circumstances.
                      Nevertheless, a refund is possible is in case you are
                      charged extra due to a technical problem.
                    </li>
                    <li>
                      The refund request should be initiated within 24 hours by
                      sending an email with all the details on{" "}
                      <a href="mailto:info@languageacademy.com.au">
                        info@languageacademy.com.au
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default Refund;
